export default __webpack_public_path__ + "resources/icons/n431-3eb4.png";